import api from 'ApiConfig';

const jobServices = {
  // Classes
  addJobPost: async (data) => {
    return api.post('/placement/create-job-post', data);
  },
  getAllJobs: async (courseId) => {
    return api.post('/placement/get-job-post', { courseId });
  },
  getUniqueJobPost: async (courseId) => {
    return api.post('/placement/get-unique-job-post', { courseId });
  },
  getCourseBatch: async (selectedBranch) => {
    return api.post('/placement/get-course-batch', { selectedBranch });
  },
  getBranch: async () => {
    return api.post('/placement/get-branch');
  },
  getPlacementReadyStudent: async (courseId, batchId, branchId) => {
    return api.post('/placement/get-placement-ready-students', {
      courseId,
      batchId,
      branchId,
    });
  },
  getStudentWiseOverview: async (courseId, batchId, branchId, studentId) => {
    return api.post('/placement/get-students-overview', {
      courseId,
      batchId,
      branchId,
      studentId,
    });
  },
  assignJobToStudents: async (payload) => {
    return api.post('/placement/assign-job', payload);
  },
  getAssignedJobs: async (studentId) => {
    return api.post('/placement/assigned-jobs', {
      studentId,
    });
  },
  updateRoundDetails: async (assignmentId, roundDetails) => {
    return api.post('/placement/update-round-details', {
      assignmentId,
      roundDetails,
    });
  },
  deleteRoundDetails: async (assignmentId, roundIndex) => {
    return api.post('/placement/delete-round', {
      assignmentId,
      roundIndex,
    });
  },
  editJob: async (jobId, jobData) => {
    return api.put(`/placement/job/${jobId}`, jobData);
  },
  getJobAssignments: async (jobId) => {
    return api.post('/placement/get-job-assignment', {
      jobId,
    });
  },
  getStudentsByJob: async (jobId, courseId, batchId, branchId) => {
    return api.post('/placement/get-students-by-job', {
      jobId,
      courseId,
      batchId,
      branchId,
    });
  },
  getAllJobPost: async (courseId) => {
    return api.post('/placement/get-all-job-posts', { courseId });
  },
  getAllPausedStudents: async (data) => {
    return api.post('/placement/get-all-paused-students', data);
  },
  getAllPlacedStudents: async (courseId, batchId, branchId) => {
    return api.post('/placement/get-all-placed-students', {
      // jobId,
      courseId,
      batchId,
      branchId,
    });
  },
  uploadAttachment: async (file) => {
    console.log(file, 'assignmnet service ');
    return api.post('/placement/upload-attachment', file);
  },
  getAttachments: async (studentId) => {
    return api.get(`/placement/get-uploaded-attachments/${studentId}`);
  },
  deleteAttachment: async (attachmentId, studentId) => {
    return api.delete(
      `/placement/delete-attachment/${attachmentId}/${studentId}`
    );
  },
  submitMockTest: async (payload) => {
    return api.post('/placement/create-mock-test-link', payload);
  },
  getMockTestLinks: async (payload) => {
    return api.post('/placement/get-mock-test-link', payload);
  },
  deleteMockTestLink: async (mockTestId) => {
    return api.delete(`/placement/delete-mock-test-link/${mockTestId}`);
  },
  updateMockTestLink: async (data) => {
    console.log(data, 'assignmnet service ');
    return api.post('/placement/update-mock-test-link', data);
  },
  // updateOfferDetails: async (assignmentId, offerDetails) => {
  //   return api.post('/placement/update-offerdetails', {
  //     assignmentId,
  //     offerDetails,
  //   });
  // },
  updateOfferDetails: (formData) => {
    return api.post('/placement/update-offerdetails', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getPlacementReadyStudentWithPausedStudent: async (
    courseId,
    batchId,
    branchId
  ) => {
    return api.post('/placement/get-placement-ready-students-includes-paused', {
      courseId,
      batchId,
      branchId,
    });
  },
  updateJobStatus: async (assignmentId, data) => {
    return api.post('/placement/update-job-status', { assignmentId, ...data });
  },
  scheduleInterview: async (assignmentId, data) => {
    return api.post('/placement/schedule-interview', { assignmentId, ...data });
  },
  cancelInterview: async (assignmentId, interviewId) => {
    return api.post('/placement/cancel-interview', { assignmentId, interviewId });
  },
  rescheduleInterview: async (assignmentId, data) => {
    return api.post('/placement/reschedule-interview', { assignmentId, ...data });
  },
  resendOffer: async (assignmentId) => {
    return api.post('/placement/resend-offer', { assignmentId });
  },
  reassignJob: async (assignmentId, assignmentExpiry, reason) => {
    return api.post('/placement/reassign-job', {
      assignmentId,
      assignmentExpiry,
      reason,
    });
  },
  deleteJobAssignment: async (assignmentId) => {
    return api.post('/placement/delete-job-assignment', { assignmentId });
  },
  editJobAssignment: async (assignmentId, jobId, assignmentExpiry) => {
    return api.post('/placement/edit-job-assignment', {
      assignmentId,
      jobId,
      assignmentExpiry,
    });
  },
};

export default jobServices;
